import { render } from "./MonitoringActiveFlowsPage.vue?vue&type=template&id=8cea38a2&scoped=true"
import script from "./MonitoringActiveFlowsPage.vue?vue&type=script&lang=js"
export * from "./MonitoringActiveFlowsPage.vue?vue&type=script&lang=js"

import "./MonitoringActiveFlowsPage.vue?vue&type=style&index=0&id=8cea38a2&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cea38a2"]])

export default __exports__